(function () {
    'use strict';

    // @ngInject
    Services.Highcharts = function Highcharts($window) {
        return $window.Highcharts;
    };


}());